import { redactText } from './url';

export interface DiagEntry {
  t: number;
  level: 'info' | 'warn' | 'error';
  scope: string;
  message: string;
}

const MAX = 80;
const entries: DiagEntry[] = [];
const listeners = new Set<() => void>();

/**
 * Local, bounded, redacted diagnostics. Nothing is sent anywhere; it is shown
 * in Details and included in the copyable report. Query values and tokens are
 * removed before an entry is stored. ALG-059
 */
export const diag = {
  log(level: DiagEntry['level'], scope: string, message: unknown): void {
    const text =
      message instanceof Error
        ? `${message.name}: ${message.message}${
            message.stack
              ? ` @ ${message.stack
                  .split('\n')
                  .slice(1, 4)
                  .map((l) => l.trim().replace(/^at /, ''))
                  .join(' < ')}`
              : ''
          }`
        : typeof message === 'string'
          ? message
          : JSON.stringify(message);
    entries.push({ t: Date.now(), level, scope, message: redactText(text).slice(0, 600) });
    if (entries.length > MAX) entries.shift();
    listeners.forEach((l) => l());
  },
  entries(): readonly DiagEntry[] {
    return entries;
  },
  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  clear(): void {
    entries.length = 0;
    listeners.forEach((l) => l());
  },
};

declare global {
  interface Window {
    __oneflowDiagnostics?: () => readonly DiagEntry[];
  }
}
if (typeof window !== 'undefined') window.__oneflowDiagnostics = () => diag.entries();
